var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapaCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1669 29.1667L5.59849 32.4622C5.34603 32.5593 5.07373 32.5935 4.8051 32.5619C4.53648 32.5302 4.27959 32.4337 4.05663 32.2805C3.83366 32.1274 3.65132 31.9223 3.52534 31.6829C3.39936 31.4436 3.33353 31.1772 3.33353 30.9067V16.0664C3.33353 15.7481 3.42471 15.4363 3.59629 15.1682C3.76788 14.9 4.01267 14.6866 4.30173 14.5532L14.1669 10V29.1667Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 29.1667L25.4167 33.3333V15L14.1667 10V29.1667Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5792 29.5695L25.4169 33.3333V14.9999L34.3233 11.0416C34.577 10.9288 34.855 10.8812 35.1318 10.9032C35.4086 10.9251 35.6756 11.0158 35.9084 11.1671C36.1412 11.3184 36.3326 11.5255 36.465 11.7696C36.5975 12.0137 36.6669 12.287 36.6669 12.5646V28.0066C36.6669 28.3471 36.5626 28.6793 36.3682 28.9587C36.1737 29.2381 35.8984 29.4513 35.5792 29.5695Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4169 6.66663C22.2579 6.66663 19.5836 8.70367 19.5836 12.5C19.5836 14.7904 23.1808 20.4211 24.7256 22.7335C24.8014 22.8474 24.9041 22.9408 25.0247 23.0054C25.1454 23.07 25.2801 23.1038 25.4169 23.1038C25.5537 23.1038 25.6884 23.07 25.809 23.0054C25.9296 22.9408 26.0324 22.8474 26.1082 22.7335C27.6529 20.4212 31.2502 14.7904 31.2502 12.5C31.2502 8.70371 28.5759 6.66663 25.4169 6.66663ZM25.4169 14.5833C24.9224 14.5833 24.4391 14.4367 24.028 14.162C23.6168 13.8873 23.2964 13.4968 23.1072 13.04C22.918 12.5832 22.8685 12.0805 22.9649 11.5956C23.0614 11.1106 23.2995 10.6652 23.6491 10.3155C23.9988 9.96589 24.4442 9.72779 24.9292 9.63133C25.4141 9.53487 25.9168 9.58437 26.3736 9.77359C26.8304 9.96281 27.2209 10.2832 27.4956 10.6944C27.7703 11.1055 27.9169 11.5888 27.9169 12.0833C27.9169 12.7463 27.6535 13.3822 27.1847 13.8511C26.7158 14.3199 26.0799 14.5833 25.4169 14.5833Z",
    fill: "#00416B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapaCor);
export default __webpack_public_path__ + "static/media/mapa-cor.97aeef6685c39fb743b1b2304951c6cc.svg";
export { ForwardRef as ReactComponent };